/**
 * Embedivideo
 */
/* eslint-disable */

;(function ($) {
	// video url
	function testUrlForMedia(pastedData, cc) {
		var success = false
		if (pastedData.match('://(www.)?youtube|youtu.be')) {
			let youtubeId
			if (pastedData.match('embed')) {
				youtubeId = pastedData.split(/embed\//)[1].split('"')[0]
			} else {
				youtubeId = pastedData.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0]
			}
			var vId = youtubeId
			var iSrc =
				'https://www.youtube-nocookie.com/embed/' +
				vId +
				'?controls=' +
				cc +
				'&color=white&showinfo=0&autoplay=1&hd=1&fs=1&rel=0'
			success = true
		} else if (pastedData.match('://(player.)?vimeo.com')) {
			var vimeoReg =
				/https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/
			var match = pastedData.match(vimeoReg)
			vId = match[3]
			iSrc =
				'https://player.vimeo.com/video/' +
				vId +
				'?title=0&byline=0&sidedock=0&portrait=0&color=ffffff&autoplay=1'
			success = true
		}
		if (success) {
			return iSrc
		}
	}

	$('a.embedvideo').on('click', function (e) {
		e.preventDefault()
		var ih = $(this).outerHeight()
		var url = $(this).attr('href')
		var iSrc = testUrlForMedia(url, 0)
		$(this)
			.parent()
			.empty()
			.append(
				'<iframe width="100%" height="' +
					ih +
					'" src="' +
					iSrc +
					'" frameborder="0" webkitAllowFullScreen allowFullScreen></iframe>'
			)
	})
})(jQuery)
